import { axios } from "@v2/shared/api";

const PARTICIPANT_ENDPOINT = "participants";
const CAR_PASS_ENDPOINT = "car-passes";
const CAR_TYPE_ENDPOINT = "car-types";
export default {
  getAll(eventId, page) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}?page=${page}`
    );
  },

  add(eventId, pass) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}`,
      pass
    );
  },

  download(eventId, passId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}/${passId}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  downloadD03(eventId, passId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}/${passId}/download/d03`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  delete(eventId, passId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}/${passId}`
    );
  },

  deleteAll(eventId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CAR_PASS_ENDPOINT}`
    );
  },

  getCarTypes() {
    return axios.get(CAR_TYPE_ENDPOINT);
  }
};
